import React from 'react';
import type { FC } from 'react';
import Autocomplete_MUI from '@material-ui/lab/Autocomplete';
import TextField_MUI from '@material-ui/core/TextField';


export interface AutocompleteProps {
    value?: any;
    onChange?: any;
    onClose?: any;
    id?: string;
    options?: any;
    getOptionLabel?: any;
    getOptionSelected?: any;
    style?: any;
    renderInput?: any;
    groupBy?: any;
    multiple?;
    size?: "small"|"medium";
    label?: string;
}

export const Autocomplete: React.FC<AutocompleteProps> = ({
    id,
    options,
    label,
    ...props
}) => {


    return (
        <Autocomplete_MUI
            id={id}
            options={options}
            renderInput={(params) => <TextField_MUI {...params} label={ label ||"Combo box"} variant="outlined" />}
            {...props}
        />
    );


}